<template>
  <div class="">
    <div
        v-if="flags.isFetching"
        class="async-loader-screen -helper--flex align-center justify-center"
      >
      <div class="lotti-wrapper">
        <lottie-player
            autoplay
            loop
            mode="normal"
            src="https://lili-mobile-images.s3.amazonaws.com/onboarding/lotti/logo_animation.json"
          ></lottie-player>
      </div>
    </div>
    <div class="welcome-wrapper">
      <TopProgressBar v-if="isMobile" :isBackShown="false" />
      <div class="welcome-partner-form-view">
        <div class="ob-step-container">

          <h2 class="title">Your personal details</h2>
          <v-form
            class="grid"
            id="v-form"
            ref="form"
            @submit.prevent="submitForm"
          >

            <v-text-field
              dense
              filled
              rounded
              validate-on-blur
              autocomplete="given-name"
              v-model="customer.firstName"
              v-on:focus="clearFieldError('firstName')"
              v-on:input="validateForm"
              :rules="firstNameRules"
              :error-messages="formFieldsErrors.firstName"
              id="firstName"
              class="full-first"
              ref="firstName"
            >
              <template v-slot:label>
                <p class="input-legend">{{ $t('intro.firstName') }}</p>
              </template>
              <template v-slot:message="{ message, key }">
                <span :key="key" id="firstNameMessage" v-html="message"></span>
              </template>
            </v-text-field>

            <v-text-field
              dense
              filled
              rounded
              validate-on-blur
              autocomplete="family-name"
              v-model="customer.lastName"
              v-on:focus="clearFieldError('lastName')"
              v-on:input="validateForm"
              :rules="lastNameRules"
              :error-messages="formFieldsErrors.lastName"
              id="lastName"
               class="full-second"
               ref="lastName"
            >
              <template v-slot:label>
                <p class="input-legend">{{ $t('intro.lastName') }}</p>
              </template>
              <template v-slot:message="{ message, key }">
                <span :key="key" id="lastNameMessage" v-html="message"></span>
              </template>
            </v-text-field>


            <v-text-field
              dense
              filled
              rounded
              v-model="customer.email"
              :disabled="true"
              :rules="inputEmailRules"
              :error-messages="
                formFieldsErrors.email || formFieldsErrors.defaultError
              "
              v-on:focus="clearFieldError('email')"
              v-on:input="validateForm"
              type="email"
              autocomplete="username email"
              validate-on-blur
              ref="email"
              id="email"
              class="full-first"
            >
              <template slot="label">
                {{ $t('intro.email') }}
              </template>
              <template v-slot:message="{ message, key }">
                <span :key="key" id="emailMessage" v-html="message"></span>
              </template>
            </v-text-field>

            <v-text-field
            ref="phone"
            dense
            filled
            rounded
            validate-on-blur
            autocomplete="off"
            v-mask="'+1 (###) ###-####'"
            type="tel"
            v-model="formattedPhoneNumber"
            v-on:focus="clearFieldError('phoneNumber')"
            v-on:input="validateForm"
            :rules="phoneNumberRules"
            :error-messages="phoneErrors"
            id="phoneNumber"
            class="full-second"
          >
            <template v-slot:label>
              <p class="input-legend">{{ $t('register.label') }}</p>
            </template>
            <template v-slot:message="{ message, key }">
              <span :key="key" id="phoneMessage" v-html="message"></span>
            </template>
            </v-text-field>



              <v-text-field
              dense
              filled
              rounded
              validate-on-blur
              autocomplete="address-line1"
              v-model="customer.line1"
              v-on:focus="clearFieldError('line1')"
              v-on:input="validateForm"
              :rules="line1"
              :error-messages="
                formFieldsErrors.line1 || formFieldsErrors.defaultError
              "
              id="line1"
              class="full-first"
              ref="line1"
            >
              <template v-slot:label>
                <p class="input-legend">{{ $t('addressDetail.line1') }}</p>
              </template>
              <template v-slot:message="{ message, key }">
                <span :key="key" id="line1Message" v-html="message"></span>
              </template>
              </v-text-field>

            <v-text-field
                dense
                filled
                rounded
                validate-on-blur
                autocomplete="address-line2"
                v-model="customer.line2"
                v-on:focus="clearFieldError('line2')"
                v-on:input="validateForm"
                :error-messages="formFieldsErrors.line2"
                id="line2"
                class="half-second line2"
                ref="line2"
              >
                <template v-slot:label>
                  <p class="input-legend" style="font-size: 13px;">{{ $t('addressDetail.line2') }}</p>
                </template>
                <template v-slot:message="{ message, key }">
                  <span :key="key" id="line2Message" v-html="message"></span>
                </template>
              </v-text-field>

              <v-text-field
                dense
                filled
                rounded
                validate-on-blur
                autocomplete="postal-code"
                v-model="customer.postalCode"
                v-on:focus="clearFieldError('postalCode')"
                v-on:input="validateForm"
                :rules="zip"
                :error-messages="formFieldsErrors.postalCode"
                inputmode="numeric"
                v-mask="'#####'"
                id="postalCode"
                ref="postaclCode"
              >
                <template v-slot:label>
                  <p class="input-legend">
                    {{ $t('addressDetail.postalCode') }}
                  </p>
                </template>
                <template v-slot:message="{ message, key }">
                  <span
                    :key="key"
                    id="postalCodeMessage"
                    v-html="message"
                  ></span>
                </template>
              </v-text-field>




            <v-text-field
              dense
              filled
              rounded
              validate-on-blur
              autocomplete="address-level2"
              v-model="customer.city"
              v-on:focus="clearFieldError('city')"
              v-on:input="validateForm"
              :rules="city"
              :error-messages="formFieldsErrors.city"
              id="city"
              class="full-first"
              ref="city"
            >
              <template v-slot:label>
                <p class="input-legend">{{ $t('addressDetail.city') }}</p>
              </template>
              <template v-slot:message="{ message, key }">
                <span :key="key" id="cityMessage" v-html="message"></span>
              </template>
            </v-text-field>

            <div class="state relative full-second" id="primary-user-state" ref="state">
              <v-select
                v-model="customer.state"
                :items="states"
                append-icon="mdi-chevron-down"
                :label="$t('addressDetail.state')"
                item-text="title"
                item-value="title"
                validate-on-blur
                :rules="stateRules"
                filled
                :menu-props="{ contentClass: 'selectScroll'}"
                >
                <template v-slot:item="data">
                  <p class="v-list-item__title" :id="data.item.id">{{ data.item.title }}</p>
                </template>
              </v-select>
          </div>




              <v-text-field
              dense
              filled
              rounded
              validate-on-blur
              autocomplete="nope"
              v-mask="'###-##-####'"
              v-model="formattedSSN"
              v-on:focus="clearFieldError('ssn')"
              v-on:input="validateForm"
              :type="flags.isSsnShown ? 'tel' : 'password'"
              :append-icon="flags.isSsnShown ? icons.mdiEyeInternal : icons.mdiEyeOffInternal"
              @click:append="flags.isSsnShown = !flags.isSsnShown"
              :rules="ssn"
              :error-messages="formFieldsErrors.ssn"
              id="ssn"
              class="full-first"
              ref="ssn"
            >
              <template v-slot:label>
                <p class="input-legend">{{ $t('kyc.ssn') }}</p>
              </template>
              <template v-slot:message="{ message, key }">
                <span :key="key" id="ssnMessage" v-html="message"></span>
              </template>
            </v-text-field>



            <v-text-field
              dense
              filled
              rounded
              validate-on-blur
              autocomplete="nope"
              v-mask="'##/##/####'"
              type="tel"
              v-model="customer.birthDateNotFormatted"
              v-on:focus="clearFieldError('birthDate')"
              v-on:input="validateForm"
              placeholder="MM/DD/YYYY"
              :rules="birthDate"
              :error-messages="
                formFieldsErrors.birthDate
                  ? formFieldsErrors.birthDate
                  : formFieldsErrors.defaultError
              "
              id="birthDate"
              class="full-second"
              ref="birthDate"
            >
              <template v-slot:label>
                <p class="input-legend">{{ $t('kyc.birthDate') }}</p>
              </template>
              <template v-slot:message="{ message, key }">
                <span :key="key" id="birthDateMessage" v-html="message"></span>
              </template>
            </v-text-field>

          <div class="horizontal-divider full"></div>

          <div class="subtitle full">Create Lili account password</div>

              <div class="password full-first">
                <v-text-field
                  dense
                  filled
                  rounded
                  validate-on-blur
                  name="password"
                  :disabled="!!obData.isPasswordSet"
                  autocomplete="new-password"
                  :type="flags.isPasswordShown ? 'text' : 'password'"
                  v-model="customer.password"
                  v-on:focus="clearFieldError('password')"
                  v-on:input="validateForm"
                  :rules="!isEditMode ? passwordRules : []"
                  :error-messages="
                    formFieldsErrors.password || formFieldsErrors.defaultError
                  "
                  :append-icon="!!obData.isPasswordSet ? '' : flags.isPasswordShown ? icons.mdiEyeInternal : icons.mdiEyeOffInternal"
                  @click:append="flags.isPasswordShown = !flags.isPasswordShown"
                  id="password"
                  ref="password"
                >
                  <template slot="label">
                    {{ $t('intro.password') }}
                  </template>
                  <template v-slot:message="{ message, key }">
                    <span :key="key" id="passwordMessage" v-html="message"></span>
                  </template>
                </v-text-field>
                <div
                  v-show="!formFieldsErrors.password"
                  class="password-dif-indicator"
                  :style="{
                    width: !customer.password ? '0%' : score.value,
                    backgroundColor: score.color
                  }"
                  id="passwordProgressBar-error"
                ></div>
              </div>
              <ul class="password-requirements">
                <li>8 characters or more </li>
                <li>At least one capital letter and one number</li>
                <li>No sequential characters</li>
              </ul>

            <div class="horizontal-divider full"></div>
            <div class="tnc-btn-wrapper full">
              <div class="tnc-content"><span>By clicking CONTINUE you agree to <a
                    @click="handleAnchorClick('terms')"
                    href="https://lili.co/legal-documents/lili-terms-of-use"
                    target="_blank"
                    id="termsOfUse"
                  >Lili's Terms of Use</a>,
                  <a
                    @click="handleAnchorClick('privacy')"
                    href="https://lili.co/legal-documents/lili-privacy-policy"
                    target="_blank"
                    id="privacyPolicy"
                  >Lili's Privacy Policy</a>
                </span>
              </div>
              <v-btn
                class="main-app-cta"
                :class="{
                  'active-cta': isCtaEnabled
                }"
                elevation="0"
                :loading="flags.isLoaderShown"
                id="elCta-partner"
                type="submit"
              >
                Continue
              </v-btn>
            </div>
          </v-form>
        </div>
        <VueRecaptcha
          id="recaptcha"
          ref="recaptcha"
          :sitekey="captchaSiteKey"
          :loadRecaptchaScript="true"
          size="invisible"
          @verify="onVerify"
          @error="onCaptchaError"
        />
      </div>
      <div class="vertical-seperator"><div class="line"></div></div>
      <div class="welcome-partner-details-view" v-if="!isMobile">
        <div class="welcome-logos-wrapper">
            <span class="main-logo-dark-blue "></span>
          </div>
        <div class="partner-details-wrapper">
          <div class="title">Lili has teamed up with Dun & Bradstreet</div>
          <div class="text">We’ve teamed up with Dun & Bradstreet to streamline your business banking application process</div>
          <div>
            <div class="list-title">Your Lili account comes with:</div>
            <ul class="text list">
              <li>Lili Visa® Debit Card</li>
              <li>No hidden fees, no overdraft fees<sup>1</sup>, no minimum deposit or minimum balance required</li>
              <li>Fast money movement including Standard or Express ACH, wire transfers, and expedited check deposits</li>
              <li>Payment apps and external bank accounts built-in integrations</li>
            </ul>
          </div>
        </div>
        <div>
        <div class="partner-footer">
          <div class="-helper--flex space-between align-center" >
            <div class="-helper--flex align-center">
              <span class="banner-fdic-dark-gray"/>
              <p class="footer-banner-content">
                Banking services provided by Sunrise Banks, N.A., Member FDIC.
              </p>
            </div>
            <span class="trust-pilot-dark-gray"/>
          </div>
          <div class="footer-patriot-act">
            <div class="act-title">USA PATRIOT Act notice</div>
            <div class="act-text">
              To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.
            </div>
            <div class="act-text">
              What this means for you: When you open an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying documents.
            </div>
            <div class="act-text balance-up">
              1. BalanceUp is a discretionary overdraft program for debit card purchases and in paid plans only. Subject to eligibility, enrollment and continued good standing. Overdraft limits are discretionary and are  $20-$200.
            </div>
          </div>
        </div>
        </div>
      </div>
      <MobileFooter v-if="isMobile"/>
    </div>
  </div>
 </template>
<script>
// eslint-disable-next-line
import * as LottiePlayer from '@lottiefiles/lottie-player'
import {params} from '../../localData'
import tracking from '../../utils/tracking'
import Bugsnag from '../../plugins/bugsnag'
import VueRecaptcha from 'vue-recaptcha'
import TopProgressBar from '../../components/globalUiComponents/TopProgressController.vue'
import MobileFooter from '../../components/globalUiComponents/MobileFooter.vue'
import {isFromLiliApp, decodeURI, formatDateToISO, updateCustomerStep} from '../../services/UtilService'
import {dataLayerHandler} from '../../services/analyticsService'
import mixpanel from '../../plugins/mixPanel'
import shared from '../../utils/shared'
import {mdiEyeOutline, mdiEyeOffOutline} from '@mdi/js'
import zxcvbn from 'zxcvbn'
import HTTP from '../../services/HttpService'
import {mapCustomerModelToPrefillData} from '../../services/entities/customerService'
import {findAndScrollToFormError, scrollToServerErrorByInput} from '../../services/entities/errorService'

export default {
  name: 'PartnerWelcome',
  components: {
    VueRecaptcha,
    TopProgressBar,
    MobileFooter
  },
  watch: {
    formFieldsErrors (errorsMap) {
      for (let field in errorsMap) {
        if (errorsMap[field]) {
          dataLayerHandler(this, 'start', 'start screen loaded')
          return
        }
      }
    },
    formattedBirthDate (date) {
      this.customer.birthDate = formatDateToISO(date)
    }
  },
  async beforeMount () {
    this.flags.isFetching = true

    if (this.isEditMode) {
      this.$store.commit('onboarding/setKeyValue', {prop: 'isPasswordSet', value: true})
      // this for edit mode purpese only - to show value to the user - it won't be saved
      this.customer.password = 'notrealpassword'
      this.$store.commit('customer/setMultiKeyValues', this.customer)
      this.flags.isFetching = false
    }
    this.flags.isFetching = false

    if (this.customer.phoneNumber) {
      setTimeout(() => {
        this.$refs.phone.focus()
        this.$refs.phone.blur()
      }, 50)
    }
  },
  mounted () {
    updateCustomerStep(this.$store, 1, this.customerData.accessToken, this.customerData.customerId)
    window.scrollTo(0, 0)
    this.customer = this.customerData
    this.formattedSSN = this.customer.ssn
    if (this.customer.phoneNumber) {
      this.formattedPhoneNumber = this.customer.phoneNumber
    }
  },
  updated () {
    this.$nextTick(function () {
      // Check if need to validate form on mounted
      if (this.shouldValidateOnMounted()) {
        this.validateForm()
      }
    })
  },
  data () {
    return {
      icons: {
        mdiEyeOffInternal: mdiEyeOffOutline,
        mdiEyeInternal: mdiEyeOutline
      },
      partnerLogo: null,
      customer: {},
      firstName: null,
      lastName: null,
      partnerName: null,
      formattedPhoneNumber: '',
      formattedSSN: '',
      institutionData: {
        id: '',
        linkSrc: '',
        bankType: ''
      },
      mandatoryFields: ['email'],
      flags: {
        isLoaderShown: false,
        isFormValid: false,
        isFetching: true,
        isPasswordShown: false,
        isEmailFieldReady: false,
        isPartnerFlow: false,
        isSsnShown: true
      },
      states: params.states,
      inputEmailRules: [
        // Indicate if the field value is falsey
        v => !!v || this.$t('validation.custom.email.required'),
        // Validate for an Email address scheme
        v =>
          /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(v) ||
          this.$t('validation.custom.email.email')
      ],
      passwordRules: [
        // Validate pass length
        v => (v && v.length >= 8) || this.$t('password.req1'),
        // check sequence
        v => this.checkSequence || this.$t('password.req10')
      ],
      firstNameRules: [
        v => !!v || this.$t('validation.custom.firstName.required'),
        v =>
          (v && v.length > 1) || this.$t('validation.custom.firstName.min'),
        v =>
          (v && v.length < 30) || this.$t('validation.custom.firstName.max'),
        v =>
          /^[a-zA-Z-_ ]*$/.test(v) ||
          this.$t('validation.custom.firstName.regex')
      ],
      lastNameRules: [
        v => !!v || this.$t('validation.custom.lastName.required'),
        v => (v && v.length > 1) || this.$t('validation.custom.lastName.min'),
        v =>
          (v && v.length < 30) || this.$t('validation.custom.lastName.max'),
        v =>
          /^[a-zA-Z-_ ]*$/.test(v) ||
          this.$t('validation.custom.lastName.regex')
      ],
      stateRules: [
        v => !!v || this.$t('validation.custom.state.required')
      ],
      phoneNumberRules: [
        v => !!v || this.$t('validation.custom.phoneNumber.required'),
        v =>
          (v && v.length > 16) ||
          this.$t('validation.custom.phoneNumber.regex'),
        v =>
          /[0-9]+/.test(v) || this.$t('validation.custom.phoneNumber.regex')
      ],
      line1: [
        v => !!v || this.$t('validation.custom.line1.required'),
        v => (v && v.length > 1) || this.$t('validation.custom.line1.min'),
        v => (v && v.length <= 40) || this.$t('validation.custom.line1.max'),
        v =>
          /^[A-Za-z0-9-\s]+$/.test(v) ||
          this.$t('validation.custom.line1.regex')
      ],
      zip: [
        v => !!v || this.$t('validation.custom.postalCode.required'),
        v =>
          (v && v.length > 4) ||
          this.$t('validation.custom.postalCode.length')
      ],
      city: [
        v => !!v || this.$t('validation.custom.city.required'),
        v => (v && v.length > 1) || this.$t('validation.custom.city.min'),
        v => (v && v.length < 21) || this.$t('validation.custom.city.max'),
        v =>
          /^[A-Za-z\s]+$/.test(v) || this.$t('validation.custom.city.format')
      ],
      ssn: [
        v => (v && v.length > 8) || this.$t('validation.custom.ssn.length')
      ],
      birthDate: [
        v => !!v || this.$t('validation.custom.birthDate.required'),
        v =>
          /^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{2})*$/.test(
            v
          ) || this.$t('validation.custom.birthDate.date_format')
      ]
    }
  },
  methods: {
    getAdSource () {
      if (typeof this.customer.adSource === 'object') {
        return JSON.stringify(this.customer.adSource)
      } else {
        return this.customer.adSource
      }
    },
    submitForm () {
      if (this.flags.isLoaderShown) return
      // If user click submit when form is not valid, the operation below will indicate the errors then return
      if (!this.flags.isFormValid) {
        this.$refs.form.validate()
        findAndScrollToFormError(this.$refs.form, true)
        return
      }
      // Toggle CTA button loader animation
      this.updateLoader(true)
      tracking.buildAdSource(this)
      // Update adSource value from customerDetails into local customer state
      this.customer.adSource = this.$customerDetails.adSource
      // Update customer state
      this.$store.commit('customer/setMultiKeyValues', this.customer)
      // Execute recaptcha validation
      this.handleRecaptcha('exec')
    },
    async onVerify (recaptchaAnswer) {
      this.handleDecodeAdSource()
      try {
        let res = {}
        if (!this.isEditMode) {
          res = await this.$store.dispatch(
            'customer/updateCustomer',
            {
              ...this.ajaxData,
              header: {
                headerName: params.httpHeaders.recaptcha,
                headerValue: recaptchaAnswer
              },
              token: this.customerData.accessToken
            },
            this
          )
          this.updateLoader(true)
          tracking.enterEmail(this)
          this.$store.commit('onboarding/setKeyValue', {prop: 'isPasswordSet', value: true})
          const { externalId, availablePromoCodes } = res
          this.handleAppsFlyerPBA(externalId)
          window.hj('identify', externalId, {
            isFromLiliApp: isFromLiliApp(),
            customerId: externalId,
            flowId: 'Dnb embedded'
          })
          this.handleAnalytics(externalId)
          this.customer.availablePromoCodes = availablePromoCodes

          // Update the customer model on the global state
          this.$store.commit('customer/setMultiKeyValues', this.customer)

          // DELETE AFTER FINISH REFACTOR (Also update the old CustomerModel)
          this.$customerDetails = {...this.$customerDetails, ...this.customer}
        } else {
          await this.$store.dispatch(
            'customer/updateCustomer',
            {
              ...this.ajaxName,
              header: {
                headerName: params.httpHeaders.auth,
                headerValue: 'lili ' + this.customer.accessToken
              }
            },
            this
          )
          this.$store.commit('customer/setMultiKeyValues', this.customer)
          // DELETE AFTER FINISH REFACTOR (Also update the old CustomerModel)
          this.$customerDetails = { ...this.$customerDetails, ...this.customer }
        }

        // --------- phone api -------
        await this.$store.dispatch(
          'customer/updateCustomer',
          {
            ...this.ajaxDataPhone,
            header: {
              headerName: params.httpHeaders.auth,
              headerValue: 'lili ' + this.customer.accessToken
            }
          },
          this
        )
        // Update the customer model on the global state
        this.customer.phoneNumber = this.formattedPhoneNumber
        this.customer.phoneNumber = this.customer.phoneNumber
          .replace('+1 ', '')
          .replace('-', '')
          .replace(' ', '')
          .replace('(', '')
          .replace(')', '')
        this.$store.commit('customer/setMultiKeyValues', this.customer)
        // DELETE AFTER FINISH REFACTOR (Also update the old CustomerModel)
        this.$customerDetails = { ...this.$customerDetails, ...this.customer }
        // --------- address api -------
        await this.$store.dispatch(
          'customer/updateCustomer',
          {
            ...this.ajaxDataAddress,
            header: {
              headerName: params.httpHeaders.auth,
              headerValue: 'lili ' + this.customer.accessToken
            }
          },
          this
        )
        this.$store.commit('customer/setMultiKeyValues', this.customer)
        // DELETE AFTER FINISH REFACTOR (Also update the old CustomerModel)
        this.$customerDetails = {...this.$customerDetails, ...this.customer}
        // --------- ssn api -------
        await this.$store.dispatch(
          'customer/updateCustomer',
          {
            ...this.ajaxDataSSN,
            header: {
              headerName: params.httpHeaders.auth,
              headerValue: 'lili ' + this.customer.accessToken
            }
          },
          this
        )
        this.customer.ssn = this.formattedSSN
        this.customer.ssn = this.customer.ssn.replaceAll('-', '')
        // The moreData flag indicates that we can pre-fill
        // Some of the customer data from API
        if (this.customer.accessToken && !this.isEditMode) {
          // this will set pre-filled data to the customer model
          await this.getAndSetCustomerPreFilledData(this.customer.customerId, this.customer.accessToken)
        }
        this.$store.commit('customer/setMultiKeyValues', this.customer)
        // DELETE AFTER FINISH REFACTOR (Also update the old CustomerModel)
        this.$customerDetails = {...this.$customerDetails, ...this.customer}
        this.flags.isLoaderShown = false
        this.$router.push({name: 'partner-business'})
      } catch (err) {
        scrollToServerErrorByInput(this.$refs, err.field)
        this.updateLoader(false)
        this.handleRecaptcha('reset')
        this.flags.isLoaderShown = false
      }
    },
    isAllrequiredFieldsDirty () {
      let mode = true
      const fields = ['password', 'email']
      fields.forEach(field => {
        if (!this.customer[field]) {
          mode = false
        }
      })
      return mode
    },
    handleAppsFlyerPBA (id) {
      var clientId = ''
      if (window.ga.getAll().length > 1) {
        clientId = window.ga.getAll()[1].get('clientId')
      } else if (window.ga.getAll().length) {
        clientId = window.ga.getAll()[0].get('clientId')
      }
      let script = document.createElement('script')
      let isInteg = !!(
        process.env.NODE_ENV === 'testing' ||
        process.env.NODE_ENV === 'development'
      )
      let pbaKey = isInteg
        ? '836c1356-5040-4914-a0ed-7fb38568c112'
        : '93be24ab-15cf-440c-9fb4-e2b8e556694f'
      script.innerHTML = `!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){
      (t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},
      t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,
      o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
      p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","pba",{pba: {webAppId: "${pbaKey}"}})
      AF('pba', 'setCustomerUserId' , '${id}');
      AF('pba', 'event', {eventType: 'EVENT', eventName: 'subscription' ,eventValue: {'CID': "${clientId}"}});
      AF('pba', 'event', {eventType: 'EVENT', eventValue: {'utc_timestamp' : "${new Date().toISOString()}"}, eventName: 'utc_timestamp'});
      AF('pba', 'event', {eventType: 'EVENT', eventName: 'Lead Creation'});`
      document.head.appendChild(script)
    },
    async onCaptchaError () {
      this.updateLoader(false)
      this.handleRecaptcha('reset')
    },
    validateForm () {
      if (!this.isAllrequiredFieldsDirty() || !this.$refs.form) return
      let isValid = this.$refs.form.validate()
      this.flags.isFormValid = isValid
    },
    clearFieldError (field) {
      this.$store.dispatch('errors/clearSpecificFieldError', [
        'defaultError',
        field
      ])
    },
    updateLoader (isLoading) {
      this.flags.isLoaderShown = isLoading
    },
    async handleAnalytics (externalId) {
      if (!externalId) {
        Bugsnag.notify(`Got bad externalId parameter: ${externalId}`)
        await mixpanel.reset()
      } else {
        await mixpanel.identify(externalId)
        tracking.startTrial(this)
        await mixpanel.people.set({
          canSelectPlan: true,
          isFromLiliApp: isFromLiliApp(),
          defaultPlanSelected: 'Smart',
          flowId: 'Dnb embedded'
        })
      }
      // insert userId to bugsnag
      Bugsnag.setUser(externalId)
      // GTM dataLayer
      window.dataLayer &&
      window.dataLayer.push({
        customer_external_id: externalId || ''
      })
    },
    handleRecaptcha (method) {
      switch (method) {
        case 'reset':
          this.$refs.recaptcha.reset()
          break
        case 'exec':
          this.$refs.recaptcha.execute()
          break

        default:
          break
      }
    },
    shouldValidateOnMounted () {
      let isValidating = true
      this.mandatoryFields.forEach(field => {
        if (!this.customer[field]) {
          isValidating = false
        }
      })
      return isValidating
    },
    deletePersistData () {
      localStorage.removeItem('persistData')
    },
    handleDecodeAdSource () {
      try {
        // Get the adSource as live object
        const adSource = JSON.parse(this.customer.adSource)
        if (!adSource) return
        // Export utm_partner and save it as variable
        const rawUtmPartner = adSource.utm_partner
        // Delete the utm_partner from the original adSource object
        delete adSource.utm_partner
        // Decode the adSource without the utm_param
        let decodedAdSource = decodeURI(JSON.stringify(adSource), 2)
        // Re-assign the utm_partner
        decodedAdSource = JSON.parse(decodedAdSource)
        decodedAdSource['utm_partner'] = rawUtmPartner
        // Set customer adSource the new decoded one
        this.customer.adSource = JSON.stringify(decodedAdSource)
      } catch (error) {
        console.error(error)
      }
    },
    getAbTestNames () {
      const names = []
      if (this.customer.isFeeABtestEnrolled) {
        names.push('BUSINESS_DETAILS_TEST_V1')
      }
      return names
    },
    async getAndSetCustomerPreFilledData (customerId, accessToken) {
      const customerDataResults = await HTTP.get(
        `v3/secureonboarding/partner/user/${customerId}`,
        null,
        {
          headerName: params.httpHeaders.auth,
          headerValue: 'lili ' + accessToken
        }
      )

      // merge the pre-filled data with the local customer model
      const mappedData = mapCustomerModelToPrefillData(customerDataResults)
      this.customer = {
        ...this.customer,
        ...mappedData,
        availablePromoCodes: customerDataResults.availablePromoCodes,
        hasSoleProprietor: customerDataResults.hasSoleProprietor
      }
    }
  },
  computed: {
    dynamicDisclaimer () {
      if (this.institutionData.bankType === 'CHOICE') return 'Choice Financial Group'
      if (this.institutionData.bankType === 'SUNRISE') return 'Sunrise Banks, N.A.'
    },
    checkSequence () {
      let isValid = shared.validatePassword(this.customer.password || '', {
        noQwertySequences: true,
        badSequenceLength: 5,
        noSequentialLength: 4
      })
      this.hasBadSequence = isValid
      return isValid
    },
    formattedBirthDate () {
      return this.customer.birthDateNotFormatted
    },
    score () {
      const result = zxcvbn(this.customer.password || '')
      switch (result.score) {
        case 4:
          return {
            color: '#44ca38',
            value: '99%'
          }
        case 3:
          return {
            color: '#44ca38',
            value: '75%'
          }
        case 2:
          return {
            color: '#f7be16',
            value: '50%'
          }
        case 1:
          return {
            color: '#f7be16',
            value: '35%'
          }
        case 0:
          return {
            color: '#e75858',
            value: '10%'
          }
        default:
          return {
            color: '#e75858',
            value: '0%'
          }
      }
    },
    phoneErrors () {
      if (this.formFieldsErrors.phoneNumber) {
        return this.formFieldsErrors.phoneNumber
      } else if (this.formFieldsErrors.defaultError) {
        return this.formFieldsErrors.defaultError
      } else {
        return ''
      }
    },
    isPassLengthValid () {
      return this.customer.password.length >= 8
    },
    isCtaEnabled () {
      return this.flags.isFormValid
    },
    isLoaderShown () {
      return this.flags.isLoaderShown
    },
    customerData () {
      return this.$store.getters['customer/data']
    },
    captchaSiteKey () {
      return process.env.VUE_APP_CAPTCHA
    },
    ajaxData () {
      return {
        method: 'put',
        endPoint: `${params.restEndpoints.lead}${this.customer.customerId}`,
        data: {
          email: this.customer.email,
          adSource: this.getAdSource(),
          abTestNames: this.getAbTestNames(),
          referralCode: '',
          password: this.customer.password,
          ...this.customer.firstName !== '' && {firstName: this.customer.firstName},
          ...this.customer.lastName !== '' && {lastName: this.customer.lastName},
          bankCode: this.institutionData.id || ''
        },
        self: this
      }
    },
    ajaxDataPhone () {
      return {
        method: 'post',
        endPoint: params.restEndpoints.phone.replace(
          '{customerid}',
          this.customer.customerId
        ),
        data: {
          phoneNumber: this.formattedPhoneNumber.replace('+1 ', '')
        },
        self: this
      }
    },
    ajaxDataAddress () {
      return {
        method: 'post',
        endPoint:
          params.restEndpoints.address + this.customer.customerId + '/address',
        data: {
          line1: this.customer.line1,
          line2: this.customer.line2,
          city: this.customer.city,
          postalCode: this.customer.postalCode,
          state: this.customer.state
        },
        self: this
      }
    },
    ajaxName () {
      return {
        method: 'post',
        endPoint:
          params.restEndpoints.user.replace(
          '{customerid}',
          this.customer.customerId
        ),
        data: {
          firstName: this.customer.firstName,
          lastName: this.customer.lastName
        },
        self: this
      }
    },
    ajaxDataSSN () {
      return {
        method: 'post',
        endPoint: params.restEndpoints.ssn + this.customer.customerId + '/kyc',
        data: {
          ssn: this.formattedSSN.replaceAll('-', ''),
          birthDate: this.customer.birthDate
        },
        self: this
      }
    },
    formFieldsErrors () {
      return this.$store.getters['errors/fieldErrors']
    },
    obData () {
      return this.$store.getters['onboarding/data']
    },
    isPartnerFlow () {
      return this.$store.getters['onboarding/isPartnerFlow']
    },
    isMobile () {
      return this.$store.getters['onboarding/isMobile']
    },
    isEditMode () {
      return this.obData.editMode
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/PartnerOnboarding/PartnerWelcome.vue